import Vue from "vue";
// import md5 from "js-md5";
import router from "@/router";
import config from "@/config";
import errorTags from "@/errorTags";

export default {
  namespaced: true,
  state: {
    _loading: {
      getAnnouncement: false,
      getPersonalMessage: false,
      getPersonalUnread: false,
      getMarqueeList: false
    },
    mqList: [],
    naList: [],
    saList: [],
    pmList: []
  },
  mutations: {
    updateNa(state, payload) {
      state.naList = payload;
    },
    updateSa(state, payload) {
      state.saList = payload;
    },
    updatePm(state, payload) {
      state.pmList = payload;
    },
    updateMq(state, payload) {
      state.mqList = payload;
    },
    delete(state) {
      // console.log("message.delete", state);
      state.naList = [];
      state.saList = [];
      state.pmList = [];
      state.mqList = [];
    },
    loading(state, payload) {
      if ("action" in payload) {
        const action = payload.action;
        const status = payload.status;
        state._loading[action] = status;
      }
    }
  },
  actions: {
    getAnnouncement(context, payload) {
      const url = config.announceListUrl();
      const feedback = {
        value: [],
        success: false,
        status: errorTags.request.failed
      };
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          start_date: payload.start_date,
          end_date: payload.end_date,
          an_type: payload.an_type
        }
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!payload) {
          feedback.status = errorTags.request.incompleted;
          reject(feedback);
          canRequest = false;
        }

        if (!("start_date" in payload)) {
          feedback.status = errorTags.message.startDateRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("end_date" in payload)) {
          feedback.status = errorTags.message.endDateRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!("an_type" in payload)) {
          feedback.status = errorTags.message.anTypeRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!payload.start_date) {
          feedback.status = errorTags.request.failed;
          reject(feedback);
          canRequest = false;
        }
        if (!payload.end_date) {
          feedback.status = errorTags.request.failed;
          reject(feedback);
          canRequest = false;
        }
        if (!payload.an_type) {
          feedback.status = errorTags.request.failed;
          reject(feedback);
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "getAnnouncement",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getAnnouncement",
                status: false
              });
              if (successResponse) {
                if (successResponse.body.results) {
                  feedback.success = false;
                  feedback.status = successResponse.body.results[0].statusdesc;
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("user/delete", payload, { root: true });
                    router.push("/expired");
                  }
                  reject(feedback);
                } else {
                  try {
                    feedback.success = true;
                    feedback.status = "";
                    feedback.value = successResponse.body.data.Table;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.status = errorTags.request.failed;
                    reject(feedback);
                  }
                }
              } else {
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getAnnouncement",
                status: false
              });
              feedback.error = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getPersonalMessage(context, payload) {
      const url = config.personalListUrl();
      const feedback = {
        value: [],
        success: false,
        status: errorTags.request.failed
      };
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        },
        data: {
          start_date: payload.start_date,
          end_date: payload.end_date
        }
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (!payload) {
          feedback.status = errorTags.request.incompleted;
          reject(feedback);
          canRequest = false;
        }

        if (!("start_date" in payload)) {
          feedback.status = errorTags.message.startDateRequired;
          reject(feedback);
          canRequest = false;
        }
        if (!("end_date" in payload)) {
          feedback.status = errorTags.message.endDateRequired;
          reject(feedback);
          canRequest = false;
        }

        if (!payload.start_date) {
          feedback.status = errorTags.request.failed;
          reject(feedback);
          canRequest = false;
        }
        if (!payload.end_date) {
          feedback.status = errorTags.request.failed;
          reject(feedback);
          canRequest = false;
        }

        if (canRequest == true) {
          context.commit("loading", {
            action: "getPersonalMessage",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getPersonalMessage",
                status: false
              });
              if (successResponse) {
                if (successResponse.body.results) {
                  feedback.success = false;
                  feedback.status = successResponse.body.results[0].statusdesc;
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("user/delete", payload, { root: true });
                    router.push("/expired");
                  }
                  reject(feedback);
                } else {
                  try {
                    feedback.success = true;
                    feedback.status = "";
                    feedback.value = successResponse.body.data.Table;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.status = errorTags.request.failed;
                    reject(feedback);
                  }
                }
              } else {
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getPersonalMessage",
                status: false
              });
              feedback.error = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getPersonalUnread(context) {
      const url = config.personalUnreadUrl();
      const feedback = {
        value: [],
        success: false,
        status: errorTags.request.failed
      };
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        }
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (canRequest == true) {
          context.commit("loading", {
            action: "getPersonalUnread",
            status: true
          });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getPersonalUnread",
                status: false
              });
              if (successResponse) {
                if (successResponse.body.results) {
                  feedback.success = false;
                  feedback.status = successResponse.body.results[0].statusdesc;
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("user/delete", payload, { root: true });
                    router.push("/expired");
                  }
                  reject(feedback);
                } else {
                  try {
                    feedback.success = true;
                    feedback.status = "";
                    feedback.value = successResponse.body.data.Table;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.status = errorTags.request.failed;
                    reject(feedback);
                  }
                }
              } else {
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getPersonalUnread",
                status: false
              });
              feedback.error = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    },
    getMarqueeList(context) {
      const url = config.marqueeListUrl();
      const feedback = {
        value: [],
        success: false,
        status: errorTags.request.failed
      };
      const body = {
        auth: {
          login_id: this.state.user.login.login_id,
          account_id: this.state.user.account.account_id,
          profile_id: this.state.user.profile.profile_id,
          auth_token: this.state.user.login.auth_token
        }
      };
      return new Promise((resolve, reject) => {
        var canRequest = true;

        if (canRequest == true) {
          context.commit("loading", { action: "getMarqueeList", status: true });
          Vue.http.post(url, body).then(
            successResponse => {
              context.commit("loading", {
                action: "getMarqueeList",
                status: false
              });
              if (successResponse) {
                if (successResponse.body.results) {
                  feedback.success = false;
                  feedback.status = successResponse.body.results[0].statusdesc;
                  if (
                    feedback.status == errorTags.session.expired ||
                    feedback.errorTag == errorTags.session.invalidSession
                  ) {
                    context.commit("user/delete", payload, { root: true });
                    router.push("/expired");
                  }
                  reject(feedback);
                } else {
                  try {
                    feedback.success = true;
                    feedback.status = "";
                    feedback.value = successResponse.body.data.Table;
                    resolve(feedback);
                  } catch (error) {
                    feedback.success = false;
                    feedback.status = errorTags.request.failed;
                    reject(feedback);
                  }
                }
              } else {
                reject(feedback);
              }
            },
            errorResponse => {
              context.commit("loading", {
                action: "getMarqueeList",
                status: false
              });
              feedback.error = errorResponse;
              reject(feedback);
            }
          );
        } else {
          reject(feedback);
        }
      });
    }
  }
};
